<button mat-button
        [type]="type ? type : null"
        [ngClass]="{
          'mat-stroked-button': stroked,
          'mat-flat-button': !stroked,
          'wrap': wrapped,
          'bold': bold,
          'critical': critical,
          'v2-full': v2Full,
          'v2-outlined': v2Outlined,
          'disabled-button': isDisabled()
        }"
        [disabled]="isDisabled()"
        color="primary"
        (click)="emitClick()">
  <span>
    <ng-content></ng-content>
  </span>
</button>
